export default "__VITE_ASSET__3b5d6d26__"